import React from "react";
import { CheckIcon, XIcon } from "lucide-react";
const ROWS: {
  label: string;
  without: string;
  with: string;
}[] = [{
  label: "Finiquitos",
  without: "Calculás a mano, con miedo a errar",
  with: "Excel que calcula solo"
}, {
  label: "Feriado legal",
  without: "Te enredás con lo progresivo",
  with: "Automático por antigüedad"
}, {
  label: "Remuneraciones",
  without: "Planillas improvisadas",
  with: "Libro ordenado y legal"
}, {
  label: "Documentos",
  without: "Googleás cada carta",
  with: "Modelos listos en Word"
}, {
  label: "Cumplir la ley",
  without: "Riesgo de multas",
  with: "Todo respaldado"
}, {
  label: "Tu tiempo",
  without: "Horas perdidas",
  with: "Minutos"
}];
export function ComparisonTable() {
  return <div className="overflow-hidden rounded-2xl border border-slate-200 bg-white shadow-md" data-id="element-131" data-mp="3dbujy3eauhgp">
      <div className="grid grid-cols-2" data-id="element-132" data-mp="1wy4fgvj9pr6j">
        <div className="bg-slate-100 px-3 py-3 text-center text-[13px] font-extrabold text-slate-600" data-id="element-133" data-mp="1x18rug6vzt8a">
          😰 Sin Kit RRHH
        </div>
        <div className="bg-[#1f4d3a] px-3 py-3 text-center text-[13px] font-extrabold text-white" data-id="element-134" data-mp="2dwnjo68x6kj9">
          😌 Con Kit RRHH
        </div>
      </div>
      <div className="divide-y divide-slate-100" data-id="element-135" data-mp="29xwq293nxl0w">
        {ROWS.map(r => <div key={r.label} className="grid grid-cols-2 text-[12px] leading-tight" data-id="element-136" data-mp="2nx65v7nyid4c">
            <div className="flex items-start gap-1.5 border-r border-slate-100 px-3 py-2.5 text-slate-500" data-id="element-137" data-mp="2ivqpvu0mywst">
              <XIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-red-400" data-id="element-138" data-mp="2wuqcyx8i33mv" />
              <span data-id="element-139" data-mp="2stmxwcya1bmp">
                <span className="block font-semibold text-slate-600" data-id="element-140" data-mp="2su6dhn0gfnxk">{r.label}</span>
                {r.without}
              </span>
            </div>
            <div className="flex items-start gap-1.5 bg-[#f3f8f4] px-3 py-2.5 text-[#1f4d3a]" data-id="element-141" data-mp="31n9rbwf0i2sq">
              <CheckIcon className="mt-0.5 h-3.5 w-3.5 shrink-0 text-[#2f6b4f]" data-id="element-142" data-mp="3gk0py3gv3aha" />
              <span data-id="element-143" data-mp="3ghwbirlc6t2r">
                <span className="block font-semibold" data-id="element-144" data-mp="3blphnx67t816">{r.label}</span>
                {r.with}
              </span>
            </div>
          </div>)}
      </div>
    </div>;
}